<template>
    <div>
        <v-search v-if="action !== 'rizhi'">
            <router-link v-if="show" :to="{path:'add'}"  class="f-right">
                <a-button type="primary" class="fr opbuttonmt">新增</a-button>
            </router-link>
            
            条件筛选
        </v-search>
        <v-tablelist ref="logTableID"  :style="{width:tableWidth}"></v-tablelist>
    </div>
</template>

<script>
import TableList from "./tablelist.vue";
import Search from "./search.vue";

export default {
    data() {
        return {
            show: true,
            tableWidth:'800px',
            action: ""
        };
    },
    methods: {
        getTableWidth(){
            this.tableWidth = (document.body.clientWidth - 240) + 'px'
        }
    },
    computed: {},
    components: {
        "v-tablelist": TableList,
        "v-search": Search
    },
    beforeMount() {
        const { path } = this.$route;
        this.action = path.split("/").pop();
        if (this.$route.path.indexOf("/jibie") > -1) {
            this.show = false;
        }
    },
    mounted() {
        this.getTableWidth();
        window.addEventListener("resize", this.getTableWidth);
    },
    destroyed(){
        window.removeEventListener("resize", this.getTableWidth);
    },
};
</script>

<style scoped>
</style>